@let dim = dimensions();

@if (src(); as url) {
  <img [src]="url" [alt]="name() + ' avatar'" class="rounded-full object-cover border border-gray-300" [class]="dim.box" />
} @else if (initials(); as letters) {
  <span
    class="flex items-center justify-center rounded-full font-semibold text-white select-none"
    [class]="initialsClass()"
    [attr.aria-label]="name()"
    role="img"
  >
    {{ letters }}
  </span>
} @else {
  <span class="flex items-center justify-center rounded-full bg-gray-200 border border-gray-300" [class]="dim.box">
    <img [src]="fallback() === 'photo' ? '/photo.svg' : '/user.svg'" alt="" class="object-contain opacity-40" [class]="dim.icon" />
  </span>
}
